import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Category, IGuid, AccessRights, ApplicationUser } from '../../../../models';
import { DashboardThumbnailWidget } from '../../../../widgets/dashboardThumbnail/dashboardThumbnail.widget';
import { ILoggerService } from '../../../../services/';

class CategoriesTreeController implements angular.IComponentController {
    dashboards: DashboardThumbnailWidget[];
    categories: Category[];
    accessRights: {
        [guid: string]: AccessRights;
    };
    users: ApplicationUser[];
    isEditMode: boolean;
    selectedItem: IGuid;
    viewModels: {
        guid: string;
        name: string;
        level: number;
        type: number;
        rights: AccessRights
    }[];

    static $inject = ['loggerService', '$translate'];

    constructor(private _loggerService: ILoggerService,
        private _$translate: angular.translate.ITranslateService) {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (this.dashboards && this.categories && this.accessRights) {
            const sortedDashboards = this.dashboards.sort((a, b) => a.sortOrder - b.sortOrder);
            const sortedCategories = this.categories.sort((a, b) => a.name < b.name ? -1 : 1);
            const noCat = sortedDashboards.filter(d => !d.categories || !d.categories.length)
                .map(d => {
                    return {
                        guid: d.guid,
                        name: d.name,
                        level: 0,
                        type: 1,
                        rights: this.accessRights[d.guid]
                    };
                });
            const withCat = [];
            sortedCategories.forEach(c => {
                withCat.push({
                    guid: c.guid,
                    name: c.name,
                    level: 0,
                    type: 0,
                    rights: this.accessRights[c.guid]
                });
                sortedDashboards
                    .filter(d => d.categories.filter(dc => (dc as any) === c.guid).length)
                    .forEach(d => {
                        withCat.push({
                            guid: d.guid,
                            name: d.name,
                            level: 1,
                            type: 1,
                            rights: this.accessRights[d.guid]
                        });
                    });
            });
            this.viewModels = noCat.concat(withCat);
            if (this.viewModels.length > 0 && !this.selectedItem) {
                this.selectedItem = this.viewModels[0];
            }
        }
    }

    getUsersAsList(users: string[]): string {
        if (users && users.length > 0 && this.users && this.users.length > 0) {
            const foundUsers = [];
            users.forEach(u => {
                const found = _.find(this.users, user => user.userId === u);
                if (found) {
                    foundUsers.push(found.name);
                }
            });
            return _.map(foundUsers).join('\n');
        }
        return '';
    }

    getRolesAsList(roles: string[]): string {
        if (roles && roles.length > 0) {
            return _.map(roles, r => this._$translate.instant(r)).join('\n');
        }
        return '';
    }

    selectItem(viewModel: any) {
        if (!this.isEditMode) {
            this.selectedItem = viewModel;
        } else {
            this._loggerService.logWarning(this._$translate.instant('Save or cancel changes before selecting another item'));
        }
    }
}

export const wtCategoriesTree: ComponentDefinition = {
    componentId: 'wtCategoriesTree',
    controller: CategoriesTreeController,
    template: require('./categoriesTree.component.html'),
    controllerAs: 'vm',
    bindings: {
        categories: '<',
        dashboards: '<',
        accessRights: '<',
        selectedItem: '=?',
        users: '<',
        isEditMode: '<'
    }
};
